const SearchService = {
  headers: {
    'Content-Type': 'application/json',
  },
  async getSingle(agencyTag) {
    const url = `/api/agency/${agencyTag}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: this.headers,
    });

    if (!response.ok) {
      return null;
    }

    const responseData = await response.json();
    return responseData.data.agency;
  },
};

export default SearchService;
